import {EditOutlined} from '@ant-design/icons';
import {
    Collapse,
    Form,
    Spin,
    Switch,
} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {useEffect, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {
    IDashboardEntity,
    IDashboardSettingsEntity,
    ISectionSettings,
} from 'components/personal-account/tabs/dashboards/dashboards-types';
import {updateDashboardSettingsAction} from 'store/api/settings-dashboards/settings-dashboards.actions';
import {
    useFetchAllDashboardsSettingsPostMutation,
} from 'store/api/settings-dashboards/settings-dashboards.api';

import s from './widget-settings-modal.module.less';

interface IWidgetSettingsProps {
    dashboardsSettings: IDashboardSettingsEntity[] | undefined;
    favorites?: IDashboardEntity[] | undefined;
    updateData: () => void;
    isEditEnabled?: boolean;
}

export const WidgetSettings = ({
    dashboardsSettings,
    favorites,
    updateData,
    isEditEnabled,
}: IWidgetSettingsProps) => {
    const [uploadDashboard] = useFetchAllDashboardsSettingsPostMutation();
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [form] = useForm();
    const allDashboards = dashboardsSettings?.map(item => [item.menus]).flat(2) as ISectionSettings[];
    const {Panel} = Collapse;

    useEffect(() => {
        if (!favorites) return;
        const initialData: Record<string, boolean | undefined> = {};
        favorites.forEach(dashboard => {
            initialData[dashboard.menuKey] = dashboard.isFavorite;
        });
        form.setFieldsValue(initialData);
    }, [favorites, dashboardsSettings]);

    const handleSave = () => {
        updateDashboardSettingsAction({
            values: form.getFieldsValue(),
            dashboards: allDashboards,
            setInitialData: updateData,
            uploadDashboard,
        });
        setModalOpen(false);
    };

    const handleClick = () => {
        setModalOpen(true);
    };

    const isFormDirty = () => {
        const values = form.getFieldsValue();
        if (Object.keys(values).length !== 0) {
            const initValues = allDashboards.filter(dashboard => Object.keys(values).includes(dashboard.itemKey));
            return initValues.some(initValue => initValue.isFavorite !== !!values[initValue.itemKey]);
        }
        return false;
    };

    return (
        <ModalOpenerComponent
            isOpen={isModalOpen}
            component={isEditEnabled ? (
                <EditOutlined
                    className="edit-icon"
                    onClick={handleClick}
                />
            ) : undefined}
            shouldConfirm={isFormDirty}
            handleSave={handleSave}
            handleCancel={() => setModalOpen(false)}
            controlLabels={{
                save: 'Сохранить',
            }}
            hideControls={{
                cancel: true,
            }}
            modalProps={{
                title: 'Настройка главной страницы',
                centered: true,
                width: '820px',
            }}
        >
            <Spin spinning={false}>
                <Form
                    form={form}
                    className={s['settings-form']}
                >
                    <Collapse
                        className={s.collapse}
                        accordion
                    >
                        {dashboardsSettings?.map((parent: IDashboardSettingsEntity) => (
                            <Panel
                                className={s.panel}
                                header={parent.sectionName}
                                key={parent.sectionName}
                            >
                                {parent?.menus?.map((child: ISectionSettings) => (
                                    <Form.Item
                                        name={child.itemKey}
                                        fieldKey={child.itemKey}
                                        label={child.name}
                                        valuePropName="checked"
                                        className={s.dashboard}
                                    >
                                        <Switch
                                            disabled={!child.isCustomize}
                                            className={s.switch}
                                        />
                                    </Form.Item>
                                ))}
                            </Panel>
                        ))}
                    </Collapse>
                </Form>
            </Spin>
        </ModalOpenerComponent>
    );
};
